module.exports = __webpack_public_path__ + "static/img/logo-min.34b8b9a8.png";